// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1032":"9401abfc","2632":"cb56378b","5204":"cb56378b"}[chunkId] + ".css";
};